import { render, staticRenderFns } from "./TitleCategory.vue?vue&type=template&id=4903e777&scoped=true&"
import script from "./TitleCategory.vue?vue&type=script&lang=js&"
export * from "./TitleCategory.vue?vue&type=script&lang=js&"
import style0 from "./TitleCategory.vue?vue&type=style&index=0&id=4903e777&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4903e777",
  null
  
)

export default component.exports